export default __webpack_public_path__ + "static/media/WorldMap.3da98a0f.svg";